/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ClipboardIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <polyline points="19.5 2.5 21.5 2.5 21.5 23.5 3.5 23.5 3.5 2.5 5.5 2.5" />
      <path d="M14.5,2.5 C14.5,1.396 13.605,0.5 12.5,0.5 C11.396,0.5 10.5,1.396 10.5,2.5 L7.5,2.5 L7.5,5.5 L17.5,5.5 L17.5,2.5 L14.5,2.5 Z" />
      <polyline points="7.5 4.5 5.5 4.5 5.5 21.5 15.5 21.5 15.5 17.5 19.5 17.5 19.5 4.5 17.5 4.5" />
      <path d="M19.5,17.5 L15.5,21.5" />
      <path d="M8.5,9.5 L16.5,9.5" />
      <path d="M8.5,11.5 L16.5,11.5" />
      <path d="M8.5,13.5 L16.5,13.5" />
      <path d="M8.5,15.5 L13,15.5" />
    </g>
  </svg>
);

export default ClipboardIcon;
